import * as Constants from './Constants';

const initialState = {
  status: false,
  cart: {},
  depletionType: '',
  shipment: {},
  payment: {},
  smsEnabledDevice: {},
  validateOrderDetails: {},
  orderDetails: {},
  lineDetails: {},
  cartHeader: {},
  getCheckoutResponse: {},
  prefetchShippingStatus: null,
};

function getCheckOutDetails(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_CHECKOUT_DETAILS_SUCCESS:
      return { ...state, status: action.response };

    case Constants.PREFETCH_SHIPPING_STATUS:
      return { ...state, prefetchShippingStatus: action.response };

    case Constants.GET_CHECKOUT_DETAILS_RESPONSE:
      console.log('Action Response:', action.response);
      return {
        ...state,
        status: true,
        getCheckoutResponse: action.response,
        cart: action.response?.data?.cart || {},
        orderDetails: action.response?.data?.cart?.orderDetails || {},
        lineDetails: action.response?.data?.cart?.lineDetails || {},
        cartHeader: action.response?.data?.cart?.cartHeader || {},
        depletionType: action.response?.data?.cart?.lineDetails?.lineInfo?.newLine1?.deviceItem?.depletionType || '',
        shipment: action.response?.data?.shipment || {},
        payment: action.response?.data?.payment || {},
        smsEnabledDevice: action.response?.data?.smsEnabledDevice || {},
        validateOrderDetails: action.response?.data?.validateOrderDetails || {},
        stateCache: Date.now(),
        songBirdUrl: action.response?.data?.payment?.songBirdUrl || '',
        songBirdIntegrity: action.response?.data?.payment?.songBirdUrlIntegrity || '' ,
      };

    case Constants.RESET_GET_CHECKOUT_DETAILS:
      return {
        ...initialState,
      };
      case Constants.UPDATE_MOVERS_LINE_DATA:
        return {
          ...state,
          lineDetails: action.payload,
        }
    default:
      return state;
  }
}

export default getCheckOutDetails;
